import { User } from 'oidc-client-ts';
import queryString from 'query-string';
import { AuthProviderProps } from 'react-oidc-context';

export const OIDC_CONFIG: AuthProviderProps = {
    authority: `${import.meta.env.VITE_KEYCLOAK_URL ?? ''}/realms/${import.meta.env.VITE_KEYCLOAK_REALM}`,
    client_id: import.meta.env.VITE_KEYCLOAK_CLIENTID ?? '',
    redirect_uri: window.location.href,
    redirectMethod: 'replace',
    onSigninCallback: () => {
        // remove the payload from the URL upon successful login
        const cleanUrl = queryString.stringifyUrl({
            url: window.location.href,
            query: {
                state: undefined,
                session_state: undefined,
                code: undefined,
            },
        });
        window.history.replaceState({}, '', cleanUrl);
    },
};

export const getUser = () => {
    const oidcStorage = sessionStorage.getItem(`oidc.user:${OIDC_CONFIG.authority}:${OIDC_CONFIG.client_id}`);
    if (!oidcStorage) {
        return null;
    }

    return User.fromStorageString(oidcStorage);
};
